import { X } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../global/AuthContext";
import "../assets/css/component/SidebarMenu.css";

type SidebarMenuProps = {
	isOpen: boolean;
	onClose: () => void;
};

export default function SidebarMenu({ isOpen, onClose }: SidebarMenuProps) {
	const { user, loading, logout } = useAuth();
	const navigate = useNavigate();

	// 공통 이동 함수
	const go = (path: string, state?: any) => {
		navigate(path, state ? { state } : undefined);
		onClose();
	};

	const goMain = (type: "recent" | "my" | "interest") => {
		go("/", { initialType: type });
	};

	const handleComingSoon = (e: React.MouseEvent) => {
		e.preventDefault();
		alert("준비중입니다.");
		onClose();
	};

	return (
		<>
			{isOpen && <div className="sidebar-overlay" onClick={onClose} />}

			<div className={`sidebar ${isOpen ? "open" : ""}`}>
				<button className="close-btn" onClick={onClose}>
					<X size={28} />
				</button>

				<nav className="menu">
					<button type="button" onClick={() => goMain("recent")}>
						메인 페이지
					</button>

					<button type="button" onClick={() => go("/myinfo")}>
						나의 정보
					</button>

					<button type="button" onClick={() => goMain("my")}>
						나의 Fact
					</button>

					<button type="button" onClick={() => goMain("interest")}>
						관심 Fact
					</button>

					<button type="button" onClick={handleComingSoon}>
						나의 Fact 통계
					</button>

					<button type="button" onClick={handleComingSoon}>
						나의 Fact Web
					</button>

					<hr />
                    <button type="button" onClick={() => go("/freeboard")}>자유게시판</button>

					<button type="button" onClick={() => go("/notices")}>
						공지사항
					</button>

					<button type="button" onClick={() => go("/about")}>
						About FactWeb
					</button>

					{!loading && user && (
						<button
							type="button"
							className="logout"
							onClick={() => {
								logout();
								onClose();
							}}
						>
							로그아웃
						</button>
					)}

					{!loading && !user && (
						<button
							type="button"
							className="login"
							onClick={() => go("/login")}
						>
							로그인
						</button>
					)}
				</nav>
			</div>
		</>
	);
}
